module.exports = __webpack_public_path__ + "static/media/angel-male.6c8541bf.png";